const RESTING_OFFSET_X = 15;
const RESTING_OFFSET_Y = -10;

type FrameCursorRect = Pick<DOMRect, "left" | "top" | "width">;

export function frameRestingCursorAnchor(rect: FrameCursorRect): {
  x: number;
  y: number;
} {
  return {
    x: rect.left + rect.width + RESTING_OFFSET_X,
    y: rect.top + RESTING_OFFSET_Y,
  };
}
